export default __webpack_public_path__ + "static/media/neutral-1.83110a55.svg";